import react, { useState } from 'react';
import i18next from 'i18next';

import ChangePasswordView from './ChangePasswordView';
import Network from '../../lib/Network';

export default function ChangePassword (props) {
  const [message, setMessage] = useState('');
  const [state, setState] = useState('initial');
  const onSubmit = (oldPassword, newPassword) => {
    setState('waiting');
    Network.postChangePassword(oldPassword, newPassword, props.jwt)
      .then(result => {
        if (result.status === 'SAME_AS_RECENT') {
          setValues('initial', 'error.SAME_AS_RECENT');
        } else if (result.status === 'NOT_COMPLEX') {
          setValues('initial', 'error.NOT_COMPLEX');
        } else if (result.status === 'SUCCESS') {
          setValues('success', 'change.success');
        } else {
          setValues('initial', 'error.unknown');
        }
      })
      .catch(error => {
        console.log(error);
        setMessage(i18next.t('error.networkError'));
      });
  }
  return <ChangePasswordView onSubmit={onSubmit} message={message} state={state} />;

  function setValues(newState, newMessage) {
    setState(newState);
    setMessage(i18next.t(newMessage));
  }
}